import React from 'react'
import moment from 'moment'
import Modal from 'react-modal'

import { tenantBilling } from '../../core/controllers/TenantBilling';
import {lease} from '../../core/controllers/Lease'
import { modal } from '../../core/utilities/modal';

import TenantPayNow from '../../components/Billing/TenantPayNow'
import TenantPaymentHistory from '../../components/Billing/TenantPaymentHistory'
import NavLink from '../../components/Routes/NavLink';
import { modalStyles } from '../../core/controllers/ModalStyles';
import { user } from '../../core/controllers/user';
import CardHolder from '../../helpers/Cards/CardHolder'
import { Card } from '../../helpers/Cards/Cards'

export default class PayOnlineTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            billingSetup: false,
            customerSplashInformation: null,
            bank_account_last_four: null,
            autoPay: 'OFF',
            contractInformation: null,
            invoices: null,
            updateBilling: false,
            can_setup: false,
            contract_id: '',
            contract_amount: 0,
            rent_due_day: null,
            totalLateRent: 0,
            showModal: false,
            currentAmount: 0,
            checked: false,
            customAmount: false,
            calculatedProcessingFee: 0.0,
            chosenPaymentMethod: "",
            paymentMethod: "",
            lastFourStr: "",
            invoices_count: 0,
            paymentMade: false,
            userHasPendingBankAccounts: false,
            pays_with_card: false,
            card_international: false
        };
    }

    componentDidMount() {
        var self = this;
        tenantBilling.getBillingInformation(function(billingInformation) {
            var userHasPendingBankAccounts = false;
            if (billingInformation.banks != null && billingInformation.banks.length > 0) {
                billingInformation.banks.map(function(bank) {
                    if (bank.status == "PENDING" && bank.default == true) {
                        userHasPendingBankAccounts = true;
                    }
                })
            }
            var autoPay = 'OFF';
            if(billingInformation.autoPay == true) {
                autoPay = 'ON';
            }

            tenantBilling.getLatestInvoice(function(response) {
                var billingSetup = billingInformation.bank_account_last_four ? true : false;
                var chosenPaymentMethod = 'Account';
                var paymentMethod = 'Account';
                var lastFourStr = '';
                if(!billingInformation.profile) {
                    billingSetup = false;
                }

                // if(billingSetup && billingInformation.splash_customer_token.payment.method <= 5) {
                //     chosenPaymentMethod = 'Credit Card';
                //     paymentMethod = 'Credit Card';
                //     lastFourStr = 'xxxx-xxxx-xxxx-' + billingInformation.splash_customer_token.payment.number;
                // } else
                if(billingSetup) {
                    lastFourStr = 'xxxxxxxxxx-' + billingInformation.bank_account_last_four;
                    chosenPaymentMethod = 'ACH';
                    paymentMethod = 'Bank Account';
                }

                var totalLateRent = 0
                response.data.map(function(invoice) {
                    if (invoice.due_at != null && moment().isAfter(moment(invoice.due_at))) {
                        if (invoice.payment_details != null) {
                            totalLateRent += self.formatAmount(invoice.payment_details.charge)
                        }
                    }
                })

                lease.getTenantData(function(tenant){
                    var leaseID = tenant.data.contract_id;
                    if (leaseID == null) {
                        self.setState({
                            invoices_count: response.count,
                            chosenPaymentMethod: chosenPaymentMethod,
                            paymentMethod: paymentMethod,
                            lastFourStr: lastFourStr,
                            invoices: response.data[0],
                            customerSplashInformation: billingInformation.profile,
                            billingSetup: billingInformation.bank_account_last_four,
                            lastFour: billingInformation.bank_account_last_four,
                            autoPay: autoPay,
                            contractInformation: billingInformation.contractInformation,
                            can_setup: billingInformation.can_setup,
                            totalLateRent: totalLateRent,
                            userHasPendingBankAccounts: userHasPendingBankAccounts,
                            pays_with_card: billingInformation.pays_with_card,
                            is_international_card: billingInformation.card_international
                        });
                        return;
                    }
                    lease.setLeaseID(leaseID);
                    lease.getLease(function(leaseData) {
                        self.setState({
                            contract_amount: self.formatAmount(leaseData.data[0].data.contract_amount).toString(),
                            rent_due_day: leaseData.data[0].data.rent_due_day,
                            contract_id: leaseData.data[0].belongTo.contract_id,
                            invoices_count: response.count,
                            chosenPaymentMethod: chosenPaymentMethod,
                            paymentMethod: paymentMethod,
                            lastFourStr: lastFourStr,
                            invoices: response.data[0],
                            customerSplashInformation: billingInformation.profile,
                            billingSetup: billingInformation.bank_account_last_four,
                            lastFour: billingInformation.bank_account_last_four,
                            autoPay: autoPay,
                            contractInformation: billingInformation.contractInformation,
                            can_setup: billingInformation.can_setup,
                            totalLateRent: totalLateRent,
                            userHasPendingBankAccounts: userHasPendingBankAccounts,
                            pays_with_card: billingInformation.pays_with_card,
                            is_international_card: billingInformation.card_international
                        });
                    });
                });
            });
        });
    }

    reload() {
        var self = this;
        tenantBilling.getBillingInformation(function(billingInformation) {
            var userHasPendingBankAccounts = false;
            if (billingInformation.banks != null && billingInformation.banks.length > 0) {
                billingInformation.banks.map(function(bank) {
                    if (bank.status == "PENDING" && bank.default == true) {
                        userHasPendingBankAccounts = true;
                    }
                })
            }
            var autoPay = 'OFF';
            if(billingInformation.autoPay == true) {
                autoPay = 'ON';
            }

            tenantBilling.getLatestInvoice(function(response) {
                var billingSetup = billingInformation.bank_account_last_four ? true : false;
                var chosenPaymentMethod = 'Account';
                var paymentMethod = 'Account';
                var lastFourStr = '';
                if(!billingInformation.profile) {
                    billingSetup = false;
                }

                // if(billingSetup && billingInformation.splash_customer_token.payment.method <= 5) {
                //     chosenPaymentMethod = 'Credit Card';
                //     paymentMethod = 'Credit Card';
                //     lastFourStr = 'xxxx-xxxx-xxxx-' + billingInformation.splash_customer_token.payment.number;
                // } else
                if(billingSetup) {
                    lastFourStr = 'xxxxxxxxxx-' + billingInformation.bank_account_last_four;
                    chosenPaymentMethod = 'ACH';
                    paymentMethod = 'Bank Account';
                }

                var totalLateRent = 0
                response.data.map(function(invoice) {
                    if (invoice.due_at != null && moment().isAfter(moment(invoice.due_at))) {
                        if (invoice.payment_details != null) {
                            totalLateRent += self.formatAmount(invoice.payment_details.charge)
                        }
                    }
                })

                lease.getTenantData(function(leaseData){
                    var leaseID = leaseData.data.contract_id;
                    if (leaseID == null) {
                        return;
                    }
                    lease.setLeaseID(leaseID);
                    lease.getLease(function(lease) {
                        self.setState({
                            contract_amount: self.formatAmount(lease.data[0].data.contract_amount).toString(),
                            rent_due_day: lease.data[0].data.rent_due_day,
                            contract_id: lease.data[0].belongTo.contract_id,
                            chosenPaymentMethod: chosenPaymentMethod,
                            paymentMethod: paymentMethod,
                            lastFourStr: lastFourStr,
                            invoices: response.data[0],
                            invoices_count: response.count,
                            customerSplashInformation: billingInformation.profile,
                            billingSetup: billingInformation.bank_account_last_four,
                            lastFour: billingInformation.bank_account_last_four,
                            autoPay: autoPay,
                            contractInformation: billingInformation.contractInformation,
                            can_setup: billingInformation.can_setup,
                            paymentMade: false,
                            totalLateRent: totalLateRent,
                            userHasPendingBankAccounts: userHasPendingBankAccounts,
                            pays_with_card: billingInformation.pays_with_card,
                            is_international_card: billingInformation.card_international
                        });
                    });
                });
            });
        });
    }

    handleOpenModal() {
        if (!this.state.billingSetup && !this.state.pays_with_card) {
            modal.showInfo("You have not set up a payment account yet!", "danger", "top", "center")
            return;
        }
        this.setState({ showModal: true });
    }

    handleCloseModal(paymentMade) {
        this.setState({
            paymentMade: paymentMade,
            showModal: false
        });
    }

    /**
     * Formats money, if not value, return 0
     * @param {*} e
     */
    formatAmount(value) {
        var money = parseFloat(value);
        if(isNaN(money) || money === 0) {
            money = 0;
        } else {
            money = money / 100;
            money.toLocaleString("en-US", {style:"currency", currency:"USD"});
        }

        return money;
    }

    /**
     * Formats money, if not value, return 0
     * @param {*} e
     */
    handleAmountChange(e) {
        this.setState({
            currentAmount: e.target.value,
            checked: false,
            customAmount: true,
        });
    }

    handleAddFee(fee, e) {
        var currentAmount
        if (this.state.customAmount == true) {
            currentAmount = 0
        } else {
            currentAmount = this.state.currentAmount
        }

        if (e.target.checked == true) {
            this.setState ({
                currentAmount: currentAmount + fee,
                checked: true,
                customAmount: false,
            })
        } else {
            this.setState ({
                currentAmount: currentAmount - fee,
                checked: false,
                customAmount: false,
            })
        }
    }

    adminFees(amount) {
        var processingFee;
        amount = parseInt(amount)
        if (amount == 0 || !amount) {
            processingFee = 0;
        } else if (this.state.chosenPaymentMethod === 'ACH') {
            processingFee = 0.75;
        } else {
            processingFee = amount * 0.029;
            processingFee += 0.31;
        }

        return processingFee;
    }

    getTotalCharge(charge) {
        charge = parseFloat(charge);
        // const processingFee = parseFloat(this.adminFees(charge));
        // this.state.calculatedProcessingFee = processingFee;
        // var total = charge + processingFee;
        return charge;
    }

    // TODO: enable credit card checking on amount
    makePayment() {
        var self = this;
        const charge = this.formatAmount(this.getTotalCharge(this.state.currentAmount));
        var creditCardFee = this.state.pays_with_card ? (1.03) : (1);
        const isInternational = this.state.is_international_card;
        var totalChargePlusFee = parseFloat(charge * creditCardFee).toFixed(2);
        if (creditCardFee > 1) {
            if (isInternational) {
                creditCardFee = 1.05;
                totalChargePlusFee = parseFloat((charge * creditCardFee) + 0.30).toFixed(2);
            } else {
                totalChargePlusFee = parseFloat((charge * creditCardFee) + 0.30).toFixed(2);
            }
        }

        if(totalChargePlusFee === undefined || totalChargePlusFee == 0) {
            modal.showInfo("There is no amount to be charged.", "danger", "top", "center");
            return;
        }

        if (this.state.pays_with_card && (totalChargePlusFee === undefined || totalChargePlusFee < 10)) {
            modal.showInfo("Minimum payment of $10 required for credit card transactions", "danger", "top", "center");
            return;
        }

        var ccMessage = '';
        if (creditCardFee > 1) {
            if (isInternational) {
                ccMessage = '</br></br>You are paying with an international card and a 5% + $0.30 fee is reflected in the charge above.';
            } else {
                ccMessage = '</br></br>You are paying with a card and a 3% + $0.30 fee is reflected in the charge above.';
            }
        }

        modal.showSuccessModalWithOK("Confirm Payment","You're about to be charged: <b>$" + charge + "</b> on " + moment().format('MMMM Do YYYY') +"?", "Yes, charge!");
        jQuery(".move-on").on('click',function() {
            tenantBilling.payManual(totalChargePlusFee, creditCardFee, "", function(response) {
                modal.showInfo("Payment was successfully submitted!", "success", "top", "center");
                self.handleCloseModal(true);
                self.setState({
                    currentAmount: 0
                });
                self.reload();
            });
        });
    }

    editBilling() {
        this.setState({
            updateBilling: this.state.updateBilling ? false : true
        });
    }

    updatePaymentMade() {
        this.setState({
            paymentMade: true
        })
    }

    render(){
        var billingSetup = this.state.billingSetup ? true : false;
        const contractInformation = this.state.contractInformation;
        const autoPay = this.state.autoPay;
        const invoices = this.state.invoices;
        const canSetup = this.state.can_setup;
        const contractAmount = this.state.contract_amount;
        const rentDueDay = this.state.rent_due_day;
        const rentDueMonth = moment().add(1,"months").format("MM");
        const rentDueYear = rentDueMonth == '01' ? moment().add(1,"years").format("YYYY") : moment().format("YYYY");

        const totalLateRent = this.state.totalLateRent.toFixed(2);
        const contract_id = this.state.contract_id;
        const currentAmount = this.state.currentAmount;
        const count = this.state.invoices_count;
        const paymentMethod = this.state.paymentMethod;
        const lastFour = this.state.lastFour;
        const lastFourStr = this.state.lastFourStr;

        const userHasPendingBankAccounts = this.state.userHasPendingBankAccounts;
        if (!canSetup) {
            return (
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="header">
                                <h4 class="title"></h4>
                                <p class="category"></p>
                            </div>
                            <div class="content">
                                <p>Your property manager must setup their payment account in order for you to start sending payments.</p>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        if (userHasPendingBankAccounts) {
            return (
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="header">
                                <h4 class="title"></h4>
                                <p class="category"></p>
                            </div>
                            <div class="content">
                                <p class="text-center">Finish verifying your primary bank account to make a payment.</p>
                                <NavLink to={"/account/billing"} class="center-content">
                                    <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-info btn-secondary btn-fill pull-left" autoComplete="off">
                                        Verify Account
                                    </button>
                                </NavLink>
                                <div class="clearfix"/>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        return (
            <div>
                <div class="row">
                    <div class="main-page-header-row col-md-12">
                        <div class="col-md-3">
                            <span class="main-page-header-title">Payments</span>
                        </div>
                        {(billingSetup || this.state.pays_with_card) && (
                            <div class="col-md-2 col-md-offset-7">
                                {user.userInfo.can_make_manual_payment == true && (
                                <button type="button" id="make_payment_modal" class="btn btn-primary btn-info btn-fill pull-right" onClick={this.handleOpenModal.bind(this)}>Make a Payment</button>
                                )}
                                <Modal
                                    isOpen={this.state.showModal}
                                    onRequestClose={this.handleCloseModal.bind(this, false)}
                                    style={modalStyles.getModalStyles()}
                                    ariaHideApp={false}
                                >
                                    <div class="row">
                                        <div class="modal-exit-icon pull-right" onClick={this.handleCloseModal.bind(this, false)}></div>
                                    </div>
                                    <div class="row">
                                        <div class="modal-header">Make a Payment</div>
                                    </div>
                                    {invoices == null ? (
                                        <div class="modal-section-title">
                                            You are all caught up with your payments.
                                        </div>
                                    ) : (
                                        <div>
                                            <div class="row">
                                                <div class="modal-section-title col-md-5">Payment Information</div>
                                            </div>
                                            <form>
                                                {/* {invoices.payment_details.rent != 0 && (
                                                    <div class="row">
                                                        <div class="col-md-1">
                                                            <input class="modal-checkbox" type="checkbox" checked={this.state.checked} onChange={this.handleAddFee.bind(this, this.formatAmount(invoices.payment_details.rent))}/>
                                                        </div>
                                                        <div class="modal-section-content col-md-5">
                                                            {"$" + this.formatAmount(invoices.payment_details.rent) + ": Rent"}
                                                        </div>
                                                    </div>
                                                )} */}
                                                {/* {invoices.payment_details.water != 0 && (
                                                    <div class="row">
                                                        <div class="col-md-1">
                                                            <input class="modal-checkbox" type="checkbox" checked={this.state.checked} onChange={this.handleAddFee.bind(this, this.formatAmount(invoices.payment_details.water))}/>
                                                        </div>
                                                        <div class="modal-section-content col-md-5">
                                                            {"$" + this.formatAmount(invoices.payment_details.water) + ": Water"}
                                                        </div>
                                                    </div>
                                                )}
                                                {invoices.payment_details.disposal != 0 && (
                                                    <div class="row">
                                                        <div class="col-md-1">
                                                            <input class="modal-checkbox" type="checkbox" checked={this.state.checked} onChange={this.handleAddFee.bind(this, this.formatAmount(invoices.payment_details.disposal))}/>
                                                        </div>
                                                        <div class="modal-section-content col-md-5">
                                                            {"$" + this.formatAmount(invoices.payment_details.disposal) + ": Disposal"}
                                                        </div>
                                                    </div>
                                                )}
                                                {invoices.payment_details.sewage != 0 && (
                                                    <div class="row">
                                                        <div class="col-md-1">
                                                            <input class="modal-checkbox" type="checkbox" checked={this.state.checked} onChange={this.handleAddFee.bind(this, this.formatAmount(invoices.payment_details.sewage))}/>
                                                        </div>
                                                        <div class="modal-section-content col-md-5">
                                                            {"$" + this.formatAmount(invoices.payment_details.sewage) + ": Sewage"}
                                                        </div>
                                                    </div>
                                                )} */}
                                                <div class="row">
                                                    <br></br>
                                                    <div class="col-md-6">
                                                        <label for="price">Amount</label>
                                                        <div class="form-group has-feedback">
                                                            <input type="number" class="form-control input-group-dollar-addon" value={currentAmount} onChange={this.handleAmountChange.bind(this)}/>
                                                            <i class="form-control-feedback fa fa-dollar" style={{left:"3px"}}></i>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label>Payment Account</label>
                                                        <input type="text" class="form-control" value={lastFourStr} placeholder="N/A" readOnly/>
                                                    </div>
                                                </div>
                                                <br/>
                                                {/* <div class="row">
                                                    <div class="col-md-6">
                                                        <label>Processing Fees</label>
                                                        <p>{"$" + this.adminFees(currentAmount)}</p>
                                                    </div>
                                                </div> */}
                                                <div class="row">
                                                    <br></br>
                                                    <div style={{textAlign: "center"}}>
                                                        <button type="button" onClick={this.makePayment.bind(this)} data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off">
                                                            Make Payment
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    )}
                                </Modal>
                            </div>
                        )}
                    </div>
                </div>
                <CardHolder width="100%" columnCount={3} paddingWidth={30}>
                    <Card
                        query={callback => {
                            callback(
                                <span>
                                    {billingSetup && (
                                        <div class="category"><strong>{lastFourStr}</strong></div>
                                    )}
                                </span>
                            );
                        }}
                        iconClass="icon-bank"
                        color="blue"
                        clickable={true}
                        url="/account/billing"
                        title={paymentMethod}
                        description= { <span class="category" style={{color: "#31658b"}}>
                            {billingSetup !== true ? "Not Linked" : `Autopay: ${autoPay}`}
                        </span> }
                    />
                    <Card
                        query={callback => {
                            callback(
                                <span>
                                    {contract_id.length > 0 ? (
                                        <div class="category"><strong>${contractAmount}</strong></div>
                                    ) : (
                                        <div style={{minHeight: "60px"}}/>
                                    )}
                                </span>
                            );
                        }}
                        iconClass="icon-apartment-outline"
                        color= "green"
                        title= "Upcoming Rent"
                        description={<span class="category"> {contract_id.length > 0 ? (
                                `${rentDueMonth}/${rentDueDay}/${rentDueYear}`
                        ) : (
                            <span><br/>No Active Lease</span>
                        )}
                        </span>}
                    />
                    <Card
                        query={callback => {
                            callback(
                                <span>
                                    {contract_id.length > 0 ? (
                                        <div class="category"><strong>${totalLateRent}</strong></div>
                                    ) : (
                                        <div style={{minHeight: "60px"}}/>
                                    )}
                                </span>
                            );
                        }}
                        iconClass="icon-money-arrow"
                        color= "red"
                        title= "Total Late Rent"
                        description= {contract_id.length > 0 ? (
                                <div class="category">Total, acumulated, past-due rent</div>
                            ) : (
                                <span class="category"><br />No Active Lease</span>
                            )}
                    />
                </CardHolder>
                <div className="row">
                    <div className="col-md-8">
                        <div class="card ps-full-width">
                            <div class="header">
                                <h4 class="title">Payment History</h4>
                                <p class="category">Complete list of all payments made</p>
                            </div>
                            <div class="content">
                                <TenantPaymentHistory
                                    paymentMade={this.state.paymentMade}
                                    hasBank={Boolean(lastFour)}
                                    hasCard={this.state.pays_with_card}
                                />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <TenantPayNow
                            invoices={invoices}
                            count={this.state.invoices_count}
                            contractInformation={contractInformation}
                            autoPay={autoPay}
                            paysWithCard={this.state.pays_with_card}
                            isInternationalCard={this.state.is_international_card}
                            billingSetup={billingSetup}
                            updatePaymentMade={this.updatePaymentMade.bind(this)}
                            reloadParent={this.reload.bind(this)}
                            displayAutoPay={true}
                            linked={Boolean(lastFour)}
                        />
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/PayOnline/PayOnline.jsx